import ApiRequester from './ApiRequester';

export default class {
  constructor() {
    this.context = '/actions';
    this.requester = null
    this.lastCall = 0;
    this.currentCall = 0;
    return this;
  }

  finishCall() {
    this.lastCall += 1;
  }

  cancelPreviousRequest() {
    if (this.currentCall !== this.lastCall) {
      this.requester.cancelPreviousRequest();
    }
  }

  all(payload) {
    this.requester = new ApiRequester();

    this.requester.method = 'GET';

    const params = new URLSearchParams(payload);
    this.requester.url = `${this.context}?${params}`;

    return this.requester.submitRequest();
  }

  detail(payload) {
    this.requester = new ApiRequester();

    this.requester.method = 'GET';

    const params = new URLSearchParams(payload);
    this.requester.url = `/actions?${params}`;

    return this.requester.submitRequest();
  }

}
